import { memo, useCallback, useState } from 'react'
import { Button, Stack, Typography } from '@mui/material'
import { useStytchB2BClient } from '@stytch/react/b2b'
import { getRedirectUrl } from '@/utils/auth'
import { showErrorSnackbar, showInfoSnackbar } from '@/utils/snackbars'

type MagicLinkRequestedProps = {
  email: string
}

function MagicLinkRequested({ email }: MagicLinkRequestedProps) {
  const stytch = useStytchB2BClient()
  const [disabled, setDisabled] = useState(false)

  const handleOnClick = useCallback(async () => {
    setDisabled(true)
    try {
      await stytch.magicLinks.email.discovery.send({
        email_address: email,
        discovery_redirect_url: getRedirectUrl(),
      })
      showInfoSnackbar(
        'A new link has been sent to your email. Please check your inbox.',
      )
    } catch {
      showErrorSnackbar(
        'An error occurred during the request. Please try again.',
      )
    } finally {
      setTimeout(() => setDisabled(false), 30000)
    }
  }, [email, stytch.magicLinks.email.discovery])

  return (
    <Stack spacing={2}>
      <Typography>Check Your Email</Typography>
      <Typography>
        An email was sent to{' '}
        <Typography color="primary" component="span">
          {email}
        </Typography>
        . Click the link to log in.
      </Typography>
      <Button onClick={handleOnClick} disabled={disabled}>
        Try Again
      </Button>
    </Stack>
  )
}

export default memo(MagicLinkRequested)
